module.exports = __webpack_public_path__ + "62601baf8734f17875debd94772a981e.svg";